import { useState, useEffect } from "react";
import axios from "axios";
import { switchEndpoint } from "../../../../../../../../../../redux/actions/endpoints";
import { storage } from "../../../../../../../../../../scopedStorage";

const useFetchPricing = () => {
  const [pricingData, setPricingData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPricing = async () => {
      setLoading(true);
      try {
        const token = storage.getItem("token");
        const useStatePricing = storage.getItem("use_state_pricing") === "true";
        const stateId = storage.getItem("state_id");
        const url =
          useStatePricing && stateId
            ? `${switchEndpoint}/state-waste-categories/${stateId}`
            : `${switchEndpoint}/all-waste-categories`;
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        // console.log(response.data)
        setPricingData(response.data || {});
      } catch (err) {
        setError(err.response?.data?.message || "Failed to load pricing");
      } finally {
        setLoading(false);
      }
    };

    fetchPricing();
  }, []);

  return { pricingData, loading, error };
};

export default useFetchPricing;
